export default __webpack_public_path__ + "static/media/flag-eritrea.f90ee8dc.svg";